import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { usePrepAuth } from '../../contexts/PrepAuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const PrepAuthCallback = () => {
  const navigate = useNavigate();
  const { checkAuth } = usePrepAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found');
          navigate('/prep/login');
          return;
        }

        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/prep/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        if (response.data.user) {
          await checkAuth();
          // Redirect admin users to admin panel, others to dashboard
          const role = response.data.user.role;
          navigate(role === 'admin' ? '/prep/admin' : '/prep/dashboard', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/prep/login');
      }
    };

    processAuth();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
      <div className="text-center text-white">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-xl">Completing sign in...</p>
      </div>
    </div>
  );
};
